(function() {
  const variants = window.productVariants;
  if (!variants) return;

  function updateSelection() {
    const selectedColor = document.querySelector('[data-index="option1"]:checked')?.value;
    if (!selectedColor) return;

    let firstAvailableInput = null;

    document.querySelectorAll('[data-index="option2"]').forEach(input => {
      const size = input.value;

      const isAvailable = variants.some(v =>
        v.option1 === selectedColor &&
        v.option2 === size &&
        v.available
      );

      // Find first available size
      if (isAvailable && !firstAvailableInput) {
        firstAvailableInput = input;
      }
    });

    // Auto-select first available size
    if (firstAvailableInput && !firstAvailableInput.checked) {
      firstAvailableInput.checked = true;
      firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // On color change
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-index="option1"]')) {
      setTimeout(updateSelection, 50);
    }
  });

  // On load
  window.addEventListener('load', updateSelection);

})();